import React, { useRef, useEffect, useState } from 'react';
import { setRTLTextPlugin } from "mapbox-gl";
import { useDispatch, useSelector } from "react-redux";
import { setLocation } from "../store/api/LocationAPI";
import '../Css/Map.css';
import mapboxgl from 'mapbox-gl';
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
mapboxgl.accessToken = 'pk.eyJ1IjoiamF2YWQyMTgyIiwiYSI6ImNrbnB4cGltMDAwaG8ycG83bTEyY3hzZzQifQ.V4ys2hufMU26Xl1PiNv0wg';
// 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA';
if (mapboxgl.getRTLTextPluginStatus() === 'unavailable') {
  setRTLTextPlugin(
    // "https://www.parsimap.com/scripts/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js"
    'https://cdn.parsimap.ir/third-party/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js'
  );
}
const Map = (props) => {
  const dispatch = useDispatch();
  const { currentLocation } = useSelector(state => { return { currentLocation: state.locationDataReducer.currentLocation } })
  let mapMarkers = [];
  const mapContainerRef = useRef(null);
  const [lng, setLng] = useState(props.location && props.location.lng ? props.location.lng : 51.6412);
  const [lat, setLat] = useState(props.location && props.location.lat ? props.location.lat : 35.6587);
  const [zoom, setZoom] = useState(props.location && props.location.zoom ? props.location.zoom : 8);
  const marker = mapMarkers[0];
  if (marker)
    marker.setLngLat(currentLocation);
  // Initialize map when component mounts
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "https://www.parsimap.com/styles/street.json",// 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom: zoom
    });

    // Add navigation control (the +/- zoom buttons)
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
    map.addControl(new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true
    }));
    const marker = new mapboxgl.Marker().setLngLat({ lng: lng, lat: lat }).addTo(map);
    dispatch(setLocation({ lng: lng, lat: lat }));
    mapMarkers.push(marker);
    map.on('move', () => {
      setLng(map.getCenter().lng.toFixed(4));
      setLat(map.getCenter().lat.toFixed(4));
      setZoom(map.getZoom().toFixed(2));
    });
    map.on('click', e => {
      mapMarkers.forEach((marker) => marker.remove());
      const marker = new mapboxgl.Marker().setLngLat(e.lngLat).addTo(map);
      dispatch(setLocation(e.lngLat));
      mapMarkers.push(marker);


    });

    // Clean up on unmount
    return () => map.remove();
  }, []); //eslint-disable-line 

  return (
    <div>
      <div className='sidebarStyle'>
        <div style={{ textAlign: "left" }}>
          Longitude: {lng} | Latitude: {lat} | Zoom: {zoom}
        </div>
      </div>
      <div className='map-container' ref={mapContainerRef} />
    </div>
  );
};

export default Map;
